import { Injectable } from '@angular/core';
import { Globals } from '../../globals';
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/internal/operators/map';


@Injectable({
  providedIn: 'root'
})
export class LearningPathService {

  constructor(private http: HttpClient, private globals: Globals) { }

  private flagSource = new BehaviorSubject<boolean>(false);
  currentFlag = this.flagSource.asObservable();

  updateFlag(flag: boolean) {
    this.flagSource.next(flag);
  }

  getResourcesListSat(entity) {
    let promise = new Promise((resolve, reject) => {
      this.http.post(this.globals.baseAPIUrl + '/get-resources-list-sat', entity)
        .toPromise()
        .then(
          res => { // Success
            resolve(res);
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }
  getdomainList() {
    let promise = new Promise((resolve, reject) => {
      this.http.get(this.globals.baseAPIUrl + '/domain/get-domain/2')
        .toPromise()
        .then(
          res => { // Success
            resolve(res);
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  getSubdomainList(entity) {
    let promise = new Promise((resolve, reject) => {
      this.http.post(this.globals.baseAPIUrl + '/subdomain/get-domain', entity)
        .toPromise()
        .then(
          res => { // Success
            resolve(res);
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  setFavourite(entity) {
    let promise = new Promise((resolve, reject) => {
      this.http.post(this.globals.baseAPIUrl + '/add-favourite-resource', entity)
        .toPromise()
        .then(
          res => { // Success
            resolve(res);
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  getFavoriteRes(entity) {
    let promise = new Promise((resolve, reject) => {
      this.http.post(this.globals.baseAPIUrl + '/get-favourite-resources-list-sat', entity)
        .toPromise()
        .then(
          res => { // Success
            resolve(res);
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  revomeFavourite(itemId: any) {
    let promise = new Promise((resolve, reject) => {
      this.http.get(this.globals.baseAPIUrl + '/remove-favourite-resource/' + itemId)
        .toPromise()
        .then(
          res => { // Success
            resolve(res);
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }
  getCompletedRes(entity) {
    let promise = new Promise((resolve, reject) => {
      this.http.post(this.globals.baseAPIUrl + '/get-completed-results-by-user-id', entity)
        .toPromise()
        .then(
          res => { // Success
            resolve(res);
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }


  exportToExcel(entity) {
    let promise = new Promise((resolve, reject) => {
      this.http.post(this.globals.baseAPIUrl + '/export-resources-learning-path', entity)
        .toPromise()
        .then(
          res => { // Success
            resolve(res);
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }


  favexportToExcel(entity) {
    let promise = new Promise((resolve, reject) => {
      this.http.post(this.globals.baseAPIUrl + '/export-resources-favourite', entity)
        .toPromise()
        .then(
          res => { // Success
            resolve(res);
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }


  public tourguideShowDisable(user_id: string): Observable<any> {
    return this.http.get(`${this.globals.baseAPIUrl}/disable-tour-guide/${user_id}`)
  }

    /**
   * Get getReourceType list
   */
  public getReourceType(): Observable<any[]> {
    const url: string = `${this.globals.baseAPIUrl}/get-reource-type`;
    return this.http.get<any[]>(url).pipe(map((data: any) => {
      return data.data;
    }));
  }

  isEligibleForLearningPath(row: any): boolean {
    if (!row) {
      return false;
    }
    const single = row.is_single_domain_complete;
    if (single === true || single === 1 || single === '1') {
      return true;
    }
    return Number(row.status_id) === 170 || Number(row.assessment_status_id) === 170;
  }

  ensureLearningPathContext(assessment: any) {
    if (!assessment) {
      return;
    }
    try {
      const existing = localStorage.getItem('userClickLp');
      if (existing) {
        const parsed = JSON.parse(existing);
        if (parsed?.assementId) {
          return;
        }
      }
    } catch (error) {}
    const assessmentId = assessment.id || assessment.assessment_id;
    if (!assessmentId) {
      return;
    }
    localStorage.setItem(
      'userClickLp',
      JSON.stringify({
        overAll: true,
        overall_rating: assessment.overall_rating,
        assementId: assessmentId,
        institute_name: assessment.institute_name,
      }),
    );
  }

  getUserSatList(entity) {
    let promise = new Promise((resolve, reject) => {
      this.http
        .post(this.globals.baseAPIUrl + '/dcm/assessments', entity)
        .toPromise()
        .then(
          (res) => {
            resolve(res);
          },
          (msg) => {
            reject(msg);
          },
        );
    });
    return promise;
  }

  async getEligibleAssessments(userId: any, userToken?: any): Promise<any[]> {
    const completedRes: any = await this.getCompletedRes({
      user_id: userId,
    }).catch(() => null);
    const completedList = Array.isArray(completedRes?.data)
      ? completedRes.data
      : [];

    const assessmentsRes: any = await this.getUserSatList({
      institute_id: null,
      license_id: null,
      user_id: [{ id: userToken || userId }],
      individual_flag: 0,
      status_id: null,
      filter: null,
      date_range: null,
      limit: 100,
      offset: 0,
      searchData: { status: '', searchQuery: '' },
      sortOrder: [{ field: 'assign_date', dir: 'desc' }],
    }).catch(() => null);

    const assessmentList = Array.isArray(assessmentsRes?.data)
      ? assessmentsRes.data
      : [];
    const eligibleFromList = assessmentList.filter((row) =>
      this.isEligibleForLearningPath(row),
    );

    const byId = new Map();
    [...completedList, ...eligibleFromList].forEach((item) => {
      const id = item?.id || item?.assessment_id;
      if (id != null && !byId.has(String(id))) {
        byId.set(String(id), item);
      }
    });
    return Array.from(byId.values());
  }
}
